import { authQueryOptions } from '@/hooks/queries/auth.queries';
import { useQuery } from '@tanstack/react-query';

export function useAuthProfile() {
  const { data, isError, isLoading, refetch } = useQuery(authQueryOptions.profile());

  return {
    isError,
    isLoading,
    profile: data ?? null,
    refetch,
  };
}
